import React, {Component, Fragment} from 'react';
import {Form, Formik} from "formik";
import {toast} from "react-toastify";
import {PhoneField, YesNoRadio} from "../Fields";
import {withTranslation} from "react-i18next";
import Loading from "./Parts/Loading";

class Ondato extends Component {
    constructor(props) {
        super(props);

        this.formSubmit = this.formSubmit.bind(this);

        this.state = {
            data: {
                phone_number: '',
                send_sms: false,
            },
            identification_id: null,
            time_outed: false,
            error_message: '',
            process_continues_in_phone: false,
            waiting: false,
        };

        this.renderForm = this.renderForm.bind(this);
        this.updateStatus = this.updateStatus.bind(this);

        if (props.ondato_identification_id !== null) {
            this.state.waiting = true;
            this.state.identification_id = props.ondato_identification_id;
            this.updateStatus();
            this.state.time_outed = false;
            setTimeout(() => {
                this.setState({time_outed: true})
            }, 10 * 60 * 1000);
        }
    }

    isOnDatoSuccesfull(data) {
        if (data.result[0] === undefined) {
            return false
        }

        if (data.result[0].document_confirmed !== 'Y') {
            return false
        }

        if (data.result[0].is_cross_checked !== 'Y') {
            return false;
        }

        if (data.result[0].status !== "APPROVED") {
            return false;
        }

        return true;
    }

    gotError(data) {
        if (data.result[0] === undefined) {
            return false
        }

        if (data.result[0].status === 'FAILED') {
            return true
        }

        if (data.result[0].document_confirmed === 'E') {
            return true
        }

        // if (data.result[0].document_confirmed === 'N') {
        //     return true
        // }

        if (data.result[0].fail_reason.length > 0) {
            return true
        }

        if (data.result[0].fail_reson_desc.length > 0) {
            return true
        }
    }

    setError(data) {

        let error_message = '';

        if (data.result[0].fail_reson_desc.length > 0) {
            error_message = data.result[0].fail_reson_desc;
        }

        if (error_message.length === 0 && data.result[0].fail_reason.length > 0) {
            error_message = data.result[0].fail_reason;
        }

        if (error_message.length === 0) {
            error_message = 'Ivyko klaida';
        }

        this.setState({error_message: error_message})
    }

    updateStatus() {
        axios.post('/api/process/' + this.props.application_token + '/ondato/status', {identification_id: this.state.identification_id})
            .then(
                data => {
                    if (this.gotError(data.data.data)) {
                        this.setError(data.data.data);
                        this.setState({
                            identification_id: null,
                            process_continues_in_phone: false,
                            waiting: false,
                        });
                    } else if (this.state.time_outed) {
                        this.setState({
                            identification_id: null,
                            process_continues_in_phone: false,
                            waiting: false,
                            error_message: this.props.t('timeout')
                        });
                    } else if (this.isOnDatoSuccesfull(data.data.data)) {
                        this.props.successCallback()
                    } else {
                        setTimeout(this.updateStatus, 5000);
                    }
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    renderForm(props) {
        return (<div className="row justify-content-center">
            <div className="col-12 ">
                <Form>

                    <div className="form-group col-lg-6">
                        <PhoneField label={this.props.t('forms.phone')}
                                    name="phone_number"
                                    {...props}
                        />
                    </div>

                    <YesNoRadio label="Pasirinkite, kokiu būdu padarysite asmens dokumento nuotrauką"
                                name={'send_sms'}
                                yes_label="Telefone"
                                no_label="Naršyklėje"
                                {...props}
                    />

                    <div>{this.state.error_message}</div>

                    {props.status && props.status.msg && <div>{props.status.msg}</div>}
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary" disabled={props.isSubmitting}>
                            Pradėti
                        </button>
                    </div>
                </Form>
            </div>
        </div>);
    }

    formSubmit(values, actions) {

        if (this.props.remote_sign) {
            values.remote_sign = true;
            values.file_token = this.props.file_token;
        }

        axios.post('/api/process/' + this.props.application_token + '/ondato', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        if (values.send_sms) {
                            this.setState({
                                process_continues_in_phone: true,
                                identification_id: data.data.data.result.identificationId
                            });
                            this.updateStatus();
                            this.setState({time_outed: false});
                            setTimeout(() => {
                                this.setState({time_outed: true})
                            }, 10 * 60 * 1000);

                        } else {
                            if (data.data.data.result.redirectUrl !== undefined && data.data.data.result.redirectUrl.length > 0) {
                                window.location = data.data.data.result.redirectUrl;
                            }
                        }
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {

        return (
            <div>
                <div className="row py-5">
                    <div className="container py-5">
                        {this.state.process_continues_in_phone ?
                            <div>
                                <Loading msg="Laukite SMS pranešimo" small={true}/>
                            </div>
                            :
                            ''
                        }

                        {this.state.waiting ?
                            <div>
                                <Loading msg="Laukiame patvirtinimo" small={true} />
                                <div className="text-center">
                                    <small>
                                        {this.props.t('ondato_one_time_url_warning')}
                                    </small>
                                </div>
                            </div>
                            :
                            ''
                        }

                        {!this.state.process_continues_in_phone && !this.state.waiting ?
                            <Fragment>
                                <div className="grey-ondato-text">
                                    {this.props.t('ondato_explanation_text')}
                                </div>
                                <div className="mb-4">
                                    <small>
                                        {this.props.t('ondato_one_time_url_warning')}
                                    </small>
                                </div>
                                <Formik
                                    initialValues={this.state.data}
                                    onSubmit={this.formSubmit}
                                    render={this.renderForm}
                                />
                            </Fragment>
                            :
                            ''
                        }

                    </div>
                </div>
            </div>)
    }
}

export default withTranslation()(Ondato);
